import { format } from 'date-fns';
import React from 'react';
import { Button } from 'reactstrap';
import DeleteIcon from '../../Res/Icon/delete.png';
import CallsPlayer from './CallsPlayer';
import utils from '../../lib/utils';

const TableRowOut = ({ calls, tab }) => {
  const strPadLeft = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  const time = parseInt(calls?.duration, 10);
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  const callDuration = `${strPadLeft(minutes, '0', 2)}:${strPadLeft(seconds, '0', 2)}`;
  const serialNumber = calls?.serialNumber?.includes('sn') ? calls?.serialNumber?.split('sn')[1] : calls?.serialNumber;
  return (
    <tr>
      <td>{calls?.callerId || ''}</td>
      <td>{calls?.destination || ''}</td>
      <td>{calls?.callType || ''}</td>
      <td>{ serialNumber || ''}</td>
      <td>{calls?.displayName !== 'null' ? calls?.displayName : calls?.epikBox?.displayName || 'N/A'}</td>
      <td>{calls?.epikBox?.location?.locationName || 'N/A'}</td>
      {tab === 'all' && (<td>{calls?.direction || ''}</td>)}
      <td>{calls?.company?.name || ''}</td>
      <td>{utils?.getDateTimeFormat(calls.createdOn, 'regular')}</td>
      <td>{utils?.getDateTimeFormat(calls.createdOn, 'time')}</td>
      <td>{callDuration || ''}</td>
    </tr>
  );
};

export default React.memo(TableRowOut);
